module.exports = __webpack_public_path__ + "0878a43e4bc9bdc23dc9acc6335e6c47.pdf";